import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { observer } from "mobx-react";
import { useStores } from "../../../../hooks";
import { Box, Grid } from "@material-ui/core";
import { Centered, CircularProgress, Typography, Space } from "../../../../common/components/libs";
import { Pagination } from "@material-ui/lab";
import ClientCard from "./components/ClientCard";
import ClientsTable from "./components/ClientsTable";
import {Trans, useTranslation} from "react-i18next";


const ClientsListPage = () => {
    const { generalStore, clientsStore } = useStores();
    const [pages, setPages] = useState(1);
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    const {i18n, t, ready} = useTranslation(["general", "clients"], { useSuspense: false });
    const locale = i18n.language;

    useEffect(() => {
        const title = t("clients:title");
        generalStore.setPageTitle(title);
        clientsStore.getClients().then(() => {
            setPages(Math.ceil(clientsStore.total / clientsStore.getLimit()));
            setIsDataLoaded(true);
        });
    }, [clientsStore, generalStore, ready]);

    const { clients } = clientsStore;

    const page = clientsStore.getPage();


    const handleChangePage = (event, value) => {
        clientsStore.setPage(value);
        clientsStore.setSkip((value - 1) * clientsStore.getLimit());
        clientsStore.getClients();
    };

    if (!isDataLoaded) {
        return (
            <Centered>
                <CircularProgress m={2}/>
            </Centered>
        );
    } else {
        return (
            <>
                <Helmet title={t("clients:title")}/>
                <Grid container spacing={4}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography variant={"h4"} mb={2}>
                            {t("clients:title")}
                        </Typography>
                        <Box display={{ xs: "none", sm: "block", md: "block", lg: "block", xl: "block" }}>
                            <ClientsTable clients={clients}/>
                        </Box>
                        <Box display={{ xs: "block", sm: "none", md: "none", lg: "none", xl: "none" }}>

                            {clients.map((client) => {
                                return (
                                    <>
                                        <ClientCard client={client}/>
                                        <Space size={10}/>
                                    </>
                                );
                            })}
                        </Box>
                        <Centered>
                            <Pagination count={pages} page={page} onChange={handleChangePage}/>
                        </Centered>
                    </Grid>
                </Grid>
            </>
        );
    }

};

export default observer(ClientsListPage);
